import { merge } from '@art-suite/art-core-ts';
import { ScanInlineProduct } from '@kaiizen/kai-scan-template-system';

// Import types from schemas - we only import types, not the schemas themselves
export type { ApiOrgProduct } from '../ApiSchemas/RecordTypes/ApiOrgProductSchema';
export type { RetailerProduct } from '../ApiSchemas/Retailer';

/**
 * Converts an organization product to a scan inline product format.
 *
 * @param orgProduct - The organization product to convert
 * @returns Scan inline product with mapped fields
 */
export const getScanInlineProductFromOrgProduct = (orgProduct: {
  id: string;
  title?: string;
  description?: string;
  price?: number;
  image?: string;
  color?: string;
  brand?: string;
  sku?: string;
  productSupplier?: string;
  productSupplierOrgId?: string;
}): ScanInlineProduct =>
  merge({
    id: orgProduct.id,
    title: orgProduct.title || 'Unknown',
    description: orgProduct.description || undefined,
    price: orgProduct.price || undefined,
    imageUrl: orgProduct.image || undefined,
    color: orgProduct.color || undefined,
    brand: orgProduct.brand || undefined,
    skus: orgProduct.sku ? [orgProduct.sku] : undefined,
    productSupplier: orgProduct.productSupplier || undefined,
    productSupplierId: orgProduct.productSupplierOrgId || undefined,
  });

/**
 * Converts an organization product to a retailer product format.
 *
 * @param orgProduct - The organization product to convert
 * @returns Retailer product with mapped fields
 */
export const getRetailerProductFromOrgProduct = (orgProduct: {
  productSupplierSku?: string;
  title?: string;
  image?: string;
  description?: string;
  price?: number;
  brand?: string;
}): {
  internetSkuId?: string;
  title?: string;
  imageUrl?: string;
  description?: string;
  price?: number;
  brand?: string;
} => ({
  internetSkuId: orgProduct.productSupplierSku,
  title: orgProduct.title,
  imageUrl: orgProduct.image,
  description: orgProduct.description,
  price: orgProduct.price,
  brand: orgProduct.brand,
});
